import { getLocale } from "../runtime";

const sv_relatedarticles = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Relaterade artiklar`
};

const relatedarticles = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_relatedarticles(inputs)
	return "relatedArticles";
};

export { relatedarticles as "relatedArticles" };